import _get from 'lodash/get';
import {
  FilterGroupingEnum,
  InterventionFilterInputObject,
} from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

interface OptionItem {
  value: string;
  label: string;
  [key: string]: unknown;
}

export function createAdditionalFilters(
  filterValues: Values,
): InterventionFilterInputObject[] {
  const filters: InterventionFilterInputObject[] = [];

  // Process Sites filter
  const sites = _get(filterValues, FieldNames.Sites, []) as OptionItem[];
  if (sites && sites.length > 0) {
    const siteIds = sites.map((site) => site.value);
    filters.push({
      siteId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: siteIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  // Process Equipment filter
  const equipment = _get(
    filterValues,
    FieldNames.Equipment,
    [],
  ) as OptionItem[];
  if (equipment && equipment.length > 0) {
    const assetIds = equipment.map((asset) => asset.value);
    filters.push({
      assetId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: assetIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  return filters;
}
